import { render, staticRenderFns } from "./TheLiveAcquisitionChart.vue?vue&type=template&id=28346850"
import script from "./TheLiveAcquisitionChart.vue?vue&type=script&lang=js"
export * from "./TheLiveAcquisitionChart.vue?vue&type=script&lang=js"
import style0 from "./TheLiveAcquisitionChart.vue?vue&type=style&index=0&id=28346850&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QItem,QItemSection,QItemLabel,QInnerLoading,QSpinner,QResizeObserver});
